import { selectAppConfig } from "./selectAppConfig";

export const selectIntroHeader = state => {
  const config = selectAppConfig(state);
  return config.blocks.intro_header || false;
};
